class WidgetService {

  getIndent(path: string[], base = 1.68): string {
    return `${(base * (path.length + 1)) + 0.4}rem`;
  }

  /**
   * 将数组拆分成长度指定的数组片段
   * @param arr
   * @param chunkSize
   * @returns
   */
  splitArray<T>(arr: T[], chunkSize: number): T[][] {
    if (arr?.length === 0) {
      return [];
    }
    const result: T[][] = [];
    for (let index = 0; index < arr.length; index += chunkSize) {
      result.push(arr.slice(index, index + chunkSize));
    }
    return result;
  }


}

export const service = new WidgetService();
